/*
    Create your gift - bundle logic
*/

let bundleArray = []

document.querySelectorAll('#create-your-gift-step-1 .form-check-input').forEach(input => {
    input.addEventListener('click', () => {
        document.querySelectorAll('#create-your-gift-step-1 .card').forEach(card => {
            card.classList.remove('active')
        })
        input.closest('.card').classList.add('active')

        document.querySelectorAll('.create-your-gift-summary-list-item').forEach((elem, index) => {
            if (index < Number(input.value)) {
                elem.removeAttribute('hidden')
            } else {
                elem.setAttribute('hidden', 'hidden')
            }
        })

        document.querySelector('#create-your-gift-summary .title b').textContent = input.value

        bundleArray = []
        buildSummary()

        setTimeout(() => {
            document.querySelector('#create-your-gift-step-2').scrollIntoView()
        }, 250)
    })
})

document.querySelectorAll('#create-your-gift-step-2 .btn-add').forEach(btn => {
    btn.addEventListener('click', () => {
        bundleArray.push({
            title: btn.dataset.title,
            variantId: btn.dataset.variantId
        })
        btn.textContent = btn.dataset.addAnother
        buildSummary()

        const list = document.querySelector('#create-your-gift-summary-list')

        list.scrollTo(bundleArray.length * 90 - 240, 0)
    })
})

document.querySelectorAll('#create-your-gift-summary .btn-close').forEach((btn, index) => {
    btn.addEventListener('click', () => {
        bundleArray.splice(index, 1)
        buildSummary()
    })
})

const buildSummary = () => {
    document.querySelectorAll('.create-your-gift-summary-list-item').forEach((elem, index) => {
        if (index < bundleArray.length) {
            elem.classList.add('active')
            elem.querySelector('.title').textContent = bundleArray[index].title
        } else {
            elem.classList.remove('active')
        }
    })
    bundleArray.forEach((elem, index) => {
        const listItem = document.querySelector(`.create-your-gift-summary-list-item:nth-child(${index + 1})`)
        listItem.classList.add('active')
    })

    const boxSize = Number(document.querySelector('.boxes-list .form-check-input:checked').value)

    bundleArray = bundleArray.slice(0, boxSize)

    if (bundleArray.length === boxSize) {
        document.querySelector('.btm-add-to-bundle').disabled = false
        document.querySelectorAll('#create-your-gift-step-2 .btn-add').forEach(btn => {
            btn.disabled = true
        })
        document.querySelector('#create-your-gift-summary').scrollIntoView()
    } else {
        document.querySelector('.btm-add-to-bundle').disabled = true
        document.querySelectorAll('#create-your-gift-step-2 .btn-add').forEach(btn => {
            btn.disabled = false
        })
    }

    if (bundleArray.length) {
        document.querySelector('.collection').classList.add('has-items')
    } else {
        document.querySelector('.collection').classList.remove('has-items')
    }
}

document.querySelectorAll('.btm-add-to-bundle').forEach(btn => {
    btn.addEventListener('click', async () => {
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        // const personalizationWrapper = document.querySelector('#product-gift-personalization')

        // const to = personalizationWrapper.querySelector('[name="attributes[To]"]')
        // const from = personalizationWrapper.querySelector('[name="attributes[From]"]')
        // const message = personalizationWrapper.querySelector('[name="attributes[Message]"]')

        // const attributes = {
        //     to: to.value,
        //     from: from.value,
        //     message: message.value
        // }

        // await fetch('/cart/update.js', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //         attributes
        //     })
        // })

        // window.populateGitNoteFields()

        const items = []

        const giftBoxSize = document.querySelector('input[name="box-check"]:checked').value

        const uuid = crypto.randomUUID()

        bundleArray.forEach(elem => {
            items.push({
                id: elem.variantId,
                qty: 1,
                properties: {
                    Box: `${giftBoxSize} Flavor Gift Box`,
                    _bundleParentId: uuid
                }
            })
        })

        items.push({
            id: Number(document.querySelector('input[name="box-check"]:checked').dataset.variantId),
            qty: 1,
            properties: {
                _bundleId: uuid
            }
        })

        console.log(items)

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items
            })
        })

        console.log(response)

        window.refreshCartContents(response)

        btn.innerHTML = btn.dataset.text

        if (document.querySelector('#offcanvas-cart')) {
            bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
        }
    })
})

setTimeout(() => {
    // eslint-disable-next-line no-new
    new AirDatepicker('#gift-personalization-delivery', {
        locale: {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear',
            dateFormat: 'MM/dd/yyyy',
            timeFormat: 'hh:mm aa',
            firstDay: 0
        },
        async onSelect (date, formattedDate, picker) {
            console.log(date.date)
            // console.log(date.formattedDate)
            // localStorage.setItem('delivery-date', date.formattedDate)

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        delivery: date.formattedDate
                    }
                })
            })
        }
    })
}, 2000)
